import { Link } from '@iheartjane/reefer';

import styles from './deselectAll.module.css';

type DeselectAllProps = {
  onClick: () => void;
};

export function DeselectAll({ onClick }: DeselectAllProps) {
  return (
    <Link ml={8} color="text-main" onClick={onClick} className={styles['text']}>
      Deselect all
    </Link>
  );
}
